import React from "react";

interface SectionCardProps {
  title: string;
  children: React.ReactNode;
  className?: string;
  showBorder?: boolean;
  titleClassName?: string;
}

/**
 * A card component for grouping related content with a title.
 * Used for sections like "Request-Based Rate Limits", "Token-Based Rate Limits", etc.
 */
export function SectionCard({
  title,
  children,
  className = "",
  showBorder = true,
  titleClassName = "",
}: SectionCardProps) {
  const borderClass = showBorder ? "border border-border" : "";
  const defaultTitleClass = titleClassName || "text-lg font-semibold mb-4 text-foreground";

  return (
    <div className={`rounded-lg bg-card shadow-sm ${borderClass} mb-6 ${className}`}>
      <div className="p-5">
        <h2 className={defaultTitleClass}>{title}</h2>
        {children}
      </div>
    </div>
  );
}

